<template>
    <div>
        <header>
            <v-container>
                <v-row no-gutters>
                    <h1 class="font-weight-light headline">
                        {{ $t("title.divisions") }}
                    </h1>
                    <v-spacer></v-spacer>
                    <v-lazy v-if="isDivisionsLoaded" transition="fade-transition">
                        <v-text-field
                            v-model="search"
                            append-icon="mdi-magnify"
                            :label="searchLabel"
                            single-line
                            dense
                            hide-details
                            style="max-width: 200px"
                            class="mr-5 pr-5"
                        ></v-text-field>
                    </v-lazy>
                    <v-lazy transition="fade-transition">
                        <v-btn
                            color="success"
                            dark
                            small
                            @click.stop="
                                dialog.divisionForm = true;
                                isDivisionEdited = false;
                            "
                            >{{ $t("general.add") }}</v-btn
                        >
                    </v-lazy>
                </v-row>
            </v-container>
        </header>
        <section class="py-7">
            <v-container>
                <v-sheet class="px-3 pt-3 pb-3" v-if="!isDivisionsLoaded">
                    <v-skeleton-loader
                        class="mx-auto"
                        type="table"
                    ></v-skeleton-loader>
                </v-sheet>
                <v-card v-else>
                    <v-data-table
                        :headers="headers"
                        :items="divisions"
                        :search="search"
                    >
                        <template v-slot:item.action="{ item }">
                            <div style="display: flex">
                                <v-tooltip top>
                                    <template v-slot:activator="{ on }">
                                        <v-icon
                                            v-tr-class-on-hover="'blue'"
                                            size="20px"
                                            color="blue"
                                            class="mr-2"
                                            @click="editUser(item)"
                                            v-on="on"
                                            >mdi-pencil-outline</v-icon
                                        >
                                    </template>
                                    <span>{{ $t("general.edit") }}</span>
                                </v-tooltip>
                                <v-tooltip top>
                                    <template v-slot:activator="{ on }">
                                        <v-icon
                                            size="22px"
                                            color="red"
                                            v-tr-class-on-hover="'red'"
                                            class="mr-2"
                                            @click="confirmDelete(item)"
                                            v-on="on"
                                            >mdi-delete-outline</v-icon
                                        >
                                    </template>
                                    <span>{{ $t("general.delete") }}</span>
                                </v-tooltip>
                            </div>
                        </template>
                        <!-- <template v-slot:item.is_active="{ item }">
                            <v-switch
                                class="mt-0 pt-0 justify-content-center"
                                hide-details
                                color="green"
                                v-model="item.is_active"
                                @change="changeStatus(item)"
                            ></v-switch>
                        </template> -->
                    </v-data-table>
                </v-card>
                <DivisionForm
                    :division="selectedDivision"
                    :visible="dialog.divisionForm"
                    :isEdited="isDivisionEdited"
                    @addDivision="addDivision"
                    @updateDivision="updateDivision"
                    @close="dialog.divisionForm = false"
                    @snackMessage="snackMessage"
                />

                <ConfirmationDialog
                    :name="selectedDivision.name"
                    :text="'divisions.delete_confirmation'"
                    v-if="dialog.confirmation"
                    @confirm="deleteDivision"
                    @cancel="cancelDelete"
                />

                <SnackMessage ref="SnackMessage" />
            </v-container>
        </section>
    </div>
</template>

<script>
import DivisionForm from "../components/DivisionForm";
import ConfirmationDialog from "../components/ConfirmationDialog";
import SnackMessage from "../components/SnackMessage";

export default {
    data() {
        return {
            divisions: [],
            isDivisionsLoaded: false,
            search: "",
            dialog: {
                confirmation: false,
                divisionForm: false,
            },
            division: {
                name: null,
                is_active: null
            },
            selectedDivision: {
                name: null,
                is_active: null
            },
            defaultDivision: {
                name: null,
                is_active: null
            },
            isDivisionEdited: false,
        };
    },

    components: {
        DivisionForm,
        ConfirmationDialog,
        SnackMessage,
    },

    computed: {
        headers() {
            return [
                {
                    text: this.$t("general.actions"),
                    value: "action",
                    sortable: false,
                },
                {
                    text: this.$t("divisions.name"),
                    align: "left",
                    sortable: false,
                    value: "name",
                },
                // {
                //     text: this.$t("divisions.is_active"),
                //     align: "left",
                //     sortable: false,
                //     value: "is_active",
                // },
                {
                    text: this.$t("general.created_at"),
                    align: "left",
                    sortable: false,
                    value: "created_at",
                },
            ];
        },
        searchLabel() {
            return this.$t("general.search");
        },
    },

    created() {
        this.getDivisions();
    },

    methods: {
        snackMessage(msg, type) {
            this.$refs.SnackMessage.showMessage(msg, type);
        },

        async getDivisions() {
            await axios
                .get("/api/divisionList", {
                    headers: {
                        Authorization:
                            "Bearer " +
                            this.$store.state.tokenData.user.access_token,
                    },
                })
                .then((response) => {
                    this.divisions = response.data;
                    this.isDivisionsLoaded = true;
                })
                .catch((error) => {
                    console.log(error.response.data);
                });
        },
        addDivision(division) {
            this.divisions.push(division);
            this.getDivisions()
        },
        editUser(item) {
            this.selectedDivision = Object.assign({}, item);
            this.dialog.divisionForm = true;
            this.isDivisionEdited = true;
        },
        updateDivision(division) {
            let index = this.divisions.findIndex((item) => item.id == division.id);
            this.divisions.splice(index, 1, division);
            this.getDivisions()
        },
        confirmDelete(item) {
            this.selectedDivision = item;
            this.dialog.confirmation = true;
        },
        cancelDelete() {
            this.dialog.confirmation = false;
        },
        async deleteDivision() {
            this.dialog.confirmation = false;
            let index = this.divisions.indexOf(this.selectedDivision);

            await axios
                .delete(`/api/deleteDivision/${this.selectedDivision.id}`, {
                    headers: {
                        Authorization:
                            "Bearer " +
                            this.$store.state.tokenData.user.access_token,
                    },
                })
                .then((response) => {
                    this.selectedDivision = this.defaultDivision;
                    this.divisions.splice(index, 1);

                    this.$refs.SnackMessage.showMessage(
                        "divisions.deleted_successfully",
                        "success"
                    );
                })
                .catch((error) => {
                    console.log(error);
                    this.$refs.SnackMessage.showMessage(
                        "general.error",
                        "error"
                    );
                });
        },
        async changeStatus(item) {
            try {
                const request = await axios.put(
                    "/api/updateStatusDivision/" + item.id,
                    item,
                    {
                        headers: {
                            Authorization:
                                "Bearer " +
                                this.$store.state.tokenData.user.access_token,
                        },
                    }
                );
                this.getDivisions()
                this.snackMessage("general.item_saved", "success");
            } catch (error) {
                console.error(error);
            }
        },
    },
};
</script>
